export const Direcional = {
  transition: "0.3s",
  primaryColor: "#003DA5",
  primaryColorFade: "rgba(0, 61, 165, 0.15)",
  tipo: "Direcional",
  accent: "rgba(190, 47, 37)",
  accentFade: "rgba(190, 47, 37, 0.15)",
};

export const Riva = {
  transition: "0.3s",
  primaryColor: "#1D3054",
  primaryColorFade: "rgba(29, 48, 84, 0.15)",
  tipo: "Riva",
  accent: "rgba(190, 47, 37)",
  accentFade: "rgba(190, 47, 37, 0.15)",
};
